import { render, staticRenderFns } from "./OtherTable.vue?vue&type=template&id=7b71f177&scoped=true"
import script from "./OtherTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtherTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71f177",
  null
  
)

export default component.exports